import styled from "styled-components";

const StyledPageFooter = styled.footer`
  padding: 48px 0;
  background-color: #2c313f;

`;

const StyledContactH2 = styled.h2`
  color: #fff;
  margin-top: 0;
  margin-bottom: 24px;
`;

const StyledPageFooterAnchor = styled.p`
  display: inline-block;
  padding: 12px 24px;
  border: 2px solid #fff;
  border-radius: 3px;
  margin: 0;
  color: #fff;
  font-size: 24px;
`;

export {
  StyledContactH2,
  StyledPageFooterAnchor
};

export default StyledPageFooter;
